export const SET_USER = 'SET_USER';
export const SET_ACC = 'SET_ACC';
export const SET_JOBS = 'SET_JOBS';
export const LOG_OUT = 'LOG_OUT';
export const AVATAR_LINK = process.env.REACT_APP_NODE_SERVER_URL + 'img/avatar/';
export const PROFILE_COVER_LINK = process.env.REACT_APP_NODE_SERVER_URL + 'img/profile/';
